<template>
	<div id="fontesMonitoradas">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="10">
				<a-row>
					<span>Tribunal:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 100%;"
						v-model="valueTribunal"			
						@change="onChangeTribunal"						
						:disabled="loading"			
						>					
					</a-input>
				</a-row>
			</a-col>
			<!-- <a-col :span="3">
				<a-row>
					<span>Tipo Credencial:</span>
				</a-row>
				<a-select
					style="width: 100%;"
					@change="onChangeTipoCredencial"
					:value="valueTipoCredencial"
					:disabled="loading"
					:allowClear="valueTipoCredencial!='4'"
					>
					<a-select-option value="4">Todos</a-select-option>
					<a-select-option value="1">Dado</a-select-option>
					<a-select-option value="2">Autos</a-select-option>
					<a-select-option value="3">Autos/Dado</a-select-option>
				</a-select>
			</a-col> -->
			<a-col :span="3">
				<a-row>
					<span>Status:</span>
				</a-row>
				<a-select
					style="width: 100%;"
					@change="onChangeStatus"
					:value="valueStatus"
					:disabled="loading"
					:allowClear="valueStatus!='3'"
					>
					<a-select-option value="3">Todos</a-select-option>
					<a-select-option value="1">Ativo</a-select-option>
					<a-select-option value="0">Inativo</a-select-option>
				</a-select>
			</a-col>
			<a-col :span="5">
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)" >
					<!-- <span>Fornecedor:</span>
					<a-input
						style="width: 100%;"
						v-model="valueFornecedor"		
						@change="onChangeFornecedor"						
						:disabled="loading"	
						>					
					</a-input> -->
					<span>Fornecedor:</span>
					<a-select
					  placeholder="Selecione o Fornecedor"
					  style="width: 100%;"
					  @change="onChangeFornecedor"
					  :v-model="valueFornecedor"
					  >
					  <a-select-option v-for="usuarios in usuarios" :key="usuarios.idUsuario">
						{{usuarios.nome}}
					</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			
			<a-col :span="3" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.stop.prevent="carregarFontesMonitoradas()"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="filteredColumns"
				:rowKey="record => record.idUsuario"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="false"
				@change="handleTableChange"
				size="middle"
			>
				<template
					slot="tipoCredencial"
					slot-scope="tipoCredencial, record"
				>{{formatarTipoCredencial(record.tipoCredencial)}}</template>
				<template slot="ativa" slot-scope="ativa, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativa"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>
				
			</a-table>
			<a-row type="flex" align="bottom">
					<a-button
						class="btnExcel"
						type="primary"
						icon="file-excel"
						size="default"
						@click.stop.prevent="exportarExcel"
					></a-button>
			</a-row>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";
import { Button } from "ant-design-vue";

const columns = [
	{
		title: "Tribunal",
		dataIndex: "tribunal",
		sorter: (a, b) => a.tribunal.localeCompare(b.tribunal),		
		scopedSlots: { customRender: "tribunal" }
	},
	{
		title: "Fornecedor",
		dataIndex: "fornecedor",
		sorter: (a, b) => a.fornecedor.localeCompare(b.fornecedor),
		scopedSlots: { customRender: "fornecedor" }
	},
	{
		title: "Ordem",
		dataIndex: "ordem",
		sorter: (a, b) => a.ordem.localeCompare(b.ordem),
		scopedSlots: { customRender: "ordem" }
	},
	{
		title: "Produto",
		dataIndex: "produto",
		width: "15%",
		scopedSlots: { customRender: "produto" },
		sorter: (a, b) => a.produto - b.produto,
		customRender: (text, record) => {
			const produtos = Array.isArray(text) ? text.map(produto => produto.produtoID) : [];
			const Descricao = { 4: "Atual. de Base", 22: "Ondemand" };

			const produtosText = produtos.length > 0
			? produtos.map(id => Descricao[id] || id).join(', ')
			: 'Todos';
			return produtosText;
		},
	},
	{
		title: "Tipo Credencial",
		dataIndex: "tipoCredencial",
		width: "15%",
		scopedSlots: { customRender: "tipoCredencial" },
		sorter: (a, b) => moment(a.tipoCredencial) - moment(b.tipoCredencial)
	},
	{
		title: "Data Atualização",
		dataIndex: "dataAtualizacao",
		width: "15%",
		scopedSlots: { customRender: "dataAtualizacao" },
		sorter: (a, b) => moment(a.dataAtualizacao) - moment(b.dataAtualizacao)
	},
	{
		title: "Situação",
		dataIndex: "ativa",
		sorter: (a, b) => a.ativa - b.ativa,		
		align: "center",
		width: "12%",
		scopedSlots: { customRender: "ativa" }
	}
];

export default {	
	name: "fontesMonitoradas",
	data() {
		return {
			idTela: 2,
			data: [],
			pagination: {},
			loading: false,
			columns,
			filter:{
				tribunal: '',
				fornecedor: '',
				tipoCredencial: "4",
				ativa: "3",
				idUsuario: null,
				idPerfil: null,
				dataAtualizacao: null,
				ordem: 0,
				produto:[]
			},
			usuarios : [],
			valueFornecedor: '',
			valueTribunal: '',
			valueStatus: '3',
			valueTipoCredencial: '4',
			selectedRowKeys: [],
		};
	},
	computed: {
    filteredColumns() {
      return this.columns.filter(column => {
        return (column.dataIndex !== "ordem" && column.dataIndex !== "produto") || this.filter.idPerfil !== 3;
      });
    }
  	},
	mounted() {    
		this.carregarFontesMonitoradas(); 
		this.recuperarUsuarios()  
	},
	methods: {
		carregarFontesMonitoradas() {
			this.loading = true;
			this.filter.idUsuario = this.$store.state.auth.idUser
			this.filter.fornecedor = this.valueFornecedor
			this.filter.idPerfil = this.$store.state.auth.idPerfilPortal
			PortalCredencialWebApi.getFontesMonitoradas(this.filter).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Relatório Fonte Monitoradas", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Relatório Fonte Monitoradas", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Relatório Fonte Monitoradas", "Erro ao tentar carregar lista de fonte monitoradas.");
			});
			
		},
		recuperarUsuarios() {
			PortalCredencialWebApi.getListarUsuarios().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Relatório Fonte Monitoradas", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Relatório Fonte Monitoradas", res.data.result);
				} else {
					this.usuarios = res.data.result;
				}
			});
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		formatarTipoCredencial(value){
			return Helpers.formatarTipo(value);
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		async exportarExcel() {
			PortalCredencialWebApi.exportarRelatorioFontesMonitoradas(this.filter)
				.then(res => {
					this.loading = false;
					let arrayValidacao = [null, "undefined", ""]
					let data = res.data;					
					if (!arrayValidacao.includes(data)) {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);						
						link.download = "Relatório_Fontes_Monitoradas" + new Date().toLocaleDateString() + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Relatório Fonte Monitoradas", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Relatório Fonte Monitoradas", "Erro ao tentar gerar arquivo.");
				});
		},
		onChangeFornecedor(value) {	
			// this.filter.fornecedor = this.valueFornecedor == '' ? null : this.valueFornecedor;

			this.data = [];
			this.usuarios = [];
			this.valueFornecedor = null;
			this.valueFornecedor = value;			
			this.recuperarUsuarios(value);
		},
		onChangeTribunal() {
			this.filter.tribunal = this.valueTribunal == '' ? null : this.valueTribunal;
		},
		onChangeTipoCredencial(value) {
			this.valueTipoCredencial = value == undefined ? '4' : value;
			this.filter.tipoCredencial = this.valueTipoCredencial == '4' ? null : this.valueTipoCredencial;
		},
		onChangeStatus(value) {
			this.valueStatus = value == undefined ? '3' : value;
			this.filter.ativa = this.valueStatus == '3' ? null : this.valueStatus;
		}
	}
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
.btnExcel {
	text-align: 'center';
	position: 'relative'; 
	width: 45px;
	height: 45px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	border-radius: 50%;
}
.btnExcel:hover {
	background-color: #0755A4;
	transition: all 0.3s ease-in;
}
</style>